import { Component, Input, OnChanges } from '@angular/core';
import { AppService } from 'common-cloudstudio';
import { ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';
import { ApolusService } from 'src/app/customer-modules/apolus/shared/services/apolus.service';

interface TableColumn {
  Key: string;
  Title: string;
  Width: string;
  Alignment: number;
}

interface TableRow {
  Data: {
    Period: any;
    Quantity: any;
    Percentage: any;
  };
  RowID: number;
  BackgroundColor: number;
}

@Component({
  selector: 'app-connectivity-table',
  templateUrl: './connectivity-table.component.html',
  styleUrls: ['./connectivity-table.component.scss'],
})
export class ConnectivityTableComponent implements OnChanges {

  @Input() data: ApolusTypes.ApolusConnectivityTable[];

  tableConfig: {
    Columns: TableColumn[];
    Content: TableRow[];
    BackgroundColor: number;
  } = {
    Columns: [],
    Content: [],
    BackgroundColor: 0x343a40
  };

  private readonly ROW_COLORS = [
    0x0d6efd, // Azul
    0xfd7e14, // Naranja
    0xffc107, // Amarillo
    0x198754, // Verde
    0x6f42c1  // Morado
  ];

  private readonly PERIOD_LABELS = [
    'Reportes hoy',
    'Reporte ayer', 
    'Reportes antier',
    'Esta semana',
    'Este mes'
  ];
  
  constructor(
    public _appService: AppService,
    public _apolusService: ApolusService
  ) {}

  ngOnChanges(): void {
    if (this.data && Array.isArray(this.data) && this.data.length > 0) {
      this.setupTable();
    }
  }

  private setupTable(): void {
    const validData = this.data.filter(this.isValidConnectivityItem);

    if (validData.length === 0) {
      this.tableConfig = { Columns: [], Content: [], BackgroundColor: 0x343a40 };
      return;
    }
    this.tableConfig = {
      Columns: [
        { Key: 'Period', Title: this._apolusService.literals.ReportedDevices, Width: '50%', Alignment: 0 },
        { Key: 'Quantity', Title: this._apolusService.literals.Quantity, Width: '25%', Alignment: 2 },
        { Key: 'Percentage', Title: this._apolusService.literals.Percentage, Width: '25%', Alignment: 2 }
      ],
      Content: validData.map((item, index) => ({
        Data: {
          Period: item.Date.Day + '/' + item.Date.Month + '/' + item.Date.Year,
          Quantity: item.Quantity,
          Percentage: item.Percentage,
        },
        RowID: index + 1,
        BackgroundColor: this.ROW_COLORS[index % this.ROW_COLORS.length]
      })),
      BackgroundColor: 0x343a40
    };
  }

  private isValidConnectivityItem = (item: any): boolean => {
    return item && 
      typeof item.Quantity !== 'undefined' && 
      typeof item.Percentage !== 'undefined';
  }

  private getPeriodLabel(index: number): string {
    return this.PERIOD_LABELS[index] || `Período ${index + 1}`;
  }

  rgbToHexa(rgb: number): string {
    if (!rgb) return '#000000';
    return '#' + rgb.toString(16).padStart(6, '0');
  }

  getAlignment(alignment: number): string {
    const alignments = ['left', 'right', 'center'];
    return alignments[alignment] || 'left';
  }
}

